import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 70vh;
  background-color: black;
  padding: 0;
  overflow: hidden;

  video {
    width: auto;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  div {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    border: 0;
  }
`;

const HowToUseDA = () => {
  const iframeRef = useRef(null); // Reference to the iframe container
  const [player, setPlayer] = useState(null); // State to hold the YouTube player
  const [isVisible, setIsVisible] = useState(false);

  // Step 1: Dynamically load the YouTube IFrame API script when the component mounts
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.youtube.com/iframe_api"; // YouTube IFrame API URL
    script.onload = () => {
      window.onYouTubeIframeAPIReady = () => {
        const youtubePlayer = new window.YT.Player(iframeRef.current, {
          videoId: "-qEPT-YZTdE?si=yOQWGOmuHj2eH8eO",
          playerVars: {
            enablesjsapi: 1,
            loop: 1,
            controls: 0, // 0 removes the controls
            playsinline: 1,
            modestbranding: 1, // Hide YouTube branding (YouTube logo)
            rel: 0, // Hide related videos after video ends
            showinfo: 0, // Hide video info (title and uploader)
            fs: 0, // Disable fullscreen button
            cc_load_policy: 0, // Disable closed captions button
            iv_load_policy: 3, // Disable annotations
          },
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        });
        setPlayer(youtubePlayer); // Save player instance to state
      };
    };
    document.body.appendChild(script); // Append script to body to load YouTube API

    return () => {
      // Cleanup: Destroy the player when component is unmounted
      if (player) {
        player.destroy();
      }
    };
  }); // Empty dependency array to run only once on mount

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
      // console.log("visible: ", entry.isIntersecting);
    });

    observer.observe(iframeRef.current);
    // console.log(player);
    // if (isVisible && player) player.playVideo();
    // else if (player) player.stopVideo();

    return () => {
      observer.disconnect();
    };
  }, [isVisible, iframeRef, player]);

  // YouTube Player Event Handlers
  const onPlayerReady = (event) => {
    console.log("YouTube Player is ready!", event);
  };

  const onPlayerStateChange = (event) => {
    console.log("Player state changed:", event.data);
    // event.data will give you the state (e.g., playing, paused, etc.)
  };

  return (
    <Container>
      <div ref={iframeRef} style={{ width: "100%", height: "100%" }}></div>
    </Container>
  );
};

export default HowToUseDA;

//   return (
//     <Container>
//       {/* <iframe
//         ref={iframeRef}
//         src="https://www.youtube.com/embed/-qEPT-YZTdE?si=yOQWGOmuHj2eH8eO"
//       ></iframe> */}

//       <div
//         id="myVideo"
//         style={{ width: "100%", height: "100%" }}
//         ref={iframeRef}
//       ></div>
//     </Container>
//   );
// };
